/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationDetailsSummary } from '../../models/organization-details-summary';

export interface AdminOrganizationBySpecialitySpecialityFhirIdGet$Params {
  specialityFhirId: string;
}

export function adminOrganizationBySpecialitySpecialityFhirIdGet(http: HttpClient, rootUrl: string, params: AdminOrganizationBySpecialitySpecialityFhirIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationDetailsSummary>> {
  const rb = new RequestBuilder(rootUrl, adminOrganizationBySpecialitySpecialityFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('specialityFhirId', params.specialityFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationDetailsSummary>;
    })
  );
}

adminOrganizationBySpecialitySpecialityFhirIdGet.PATH = '/Admin/OrganizationBySpeciality/{specialityFhirId}';
